var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wet-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return undefined},proxy:true},{key:"content",fn:function(){return [_c('stacked-area',{ref:"StackedArea",attrs:{"options":_vm.options,"aspectRatio":3,"chartData":_vm.chartData,"tooltip-callback":_vm.tooltipCallback}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }